import { trackClientEvent } from 'analytics/analytics'

export function trackDurationMs(subject: string, startTimeMs: number) {
  const durationMs = Math.round(performance.now() - startTimeMs)
  trackClientEvent({
    subject,
    action: String(durationMs),
    category: 'performance',
    type: 'nonInteraction',
  })
}
